import styles from '../ProductCardBenefits/ProductCardBenefits.module.scss';
import React from 'react';
import {
  Button,
  Content,
  FontAwesomeProIcon,
  List,
  ListItem,
  Modal,
} from '@wienenergiegithub/ui-next';
import { DialogDisclosure, useDialogStore } from '@ariakit/react';

const ProductCardBenefit = ({ vorteil }) => {
  const dialog = useDialogStore({ animated: true });

  return (
    <div className={styles.container}>
      {vorteil.vorteile_text}
      {vorteil.vorteile_icon?.length > 0 && (
        <>
          <DialogDisclosure
            render={
              <Button className={styles.informationButton} shape="bubble">
                <FontAwesomeProIcon
                  className={styles.infoIcon}
                  color="primary"
                  icon="info-circle"
                  role="presentation"
                />
              </Button>
            }
            store={dialog}
          />
          <Modal
            className={styles.modal}
            header={vorteil.vorteile_text}
            store={dialog}
            theme="default"
          >
            <Content as="span" className={styles.modal} noSpacing withParser>
              {vorteil.vorteile_icon}
            </Content>
          </Modal>
        </>
      )}
    </div>
  );
};

const ProductCardBenefits = ({ vorteile, aktionsInfo }) => (
  <div>
    <List
      align="center"
      icon={
        <FontAwesomeProIcon
          icon="circle-check"
          role="presentation"
          type="solid"
        />
      }
      iconSize="small"
      noSpacing
      type="checkmark"
    >
      {vorteile?.map(vorteil => (
        <ListItem key={vorteil.vorteile_text}>
          <ProductCardBenefit vorteil={vorteil} />
        </ListItem>
      ))}
    </List>
    {!!aktionsInfo && (
      <List
        className={styles.aktionsInfo}
        icon={
          <FontAwesomeProIcon icon="gift" role="presentation" type="solid" />
        }
        iconSize="small"
        noSpacing
        type="checkmark"
        variant="gold"
      >
        <ListItem key={aktionsInfo}>
          <Content
            as="span"
            className={styles.aktionsInfoText}
            noSpacing
            withParser
          >
            {aktionsInfo}
          </Content>
        </ListItem>
      </List>
    )}
  </div>
);

export default ProductCardBenefits;
